import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { RequestService } from '../request';
import { IAddReportPanelRequest, ICreatePanelRequest, IDeleteReportPanelRequest, IPanel, IPanelReport, IUpdatePanelRequest } from './defs';

@Injectable({
  providedIn: 'root'
})
export class PanelsService {

  constructor(
    private request: RequestService
  ) { }


  public getList(): Observable<IPanel[]> {
    return this.request.get('/api/panels');
  }

  public getToken(): Observable<any> {
    return this.request.get('/api/panels/token');
  }

  public getMyPanels(): Observable<IPanel[]> {
    return this.request.get('/api/panels/my-panels');
  }

  public getPanelById(id: number): Observable<IPanel> {
    if (!id) {
      throw new Error('Invalid panelId for GetPanelById');
    }

    return this.request.get(`/api/panels/${id}`);
  }

  public createPanel(request: ICreatePanelRequest): Observable<IPanel> {
    return this.request.post('/api/panels', request);
  }

  public updatePanel(request: IUpdatePanelRequest): Observable<IPanel> {
    return this.request.put(`/api/panels/${request.id}`, request);
  }

  public deletePanel(ids: number[]): Observable<IPanel[]> {
    return forkJoin(ids.map(id => this.request.delete(`/api/panels/${id}`)));
  }

  public getReportsByPanelId(panelId): Observable<IPanelReport[]> {
    return this.request.get(`/api/panels/${panelId}/reports`);
  }

  public addReport(request: IAddReportPanelRequest): Observable<any> {
    return this.request.post(`/api/panels/reports/add`, request);
  }

  public deleteReport(request: IDeleteReportPanelRequest): Observable<any> {
    return this.request.post(`/api/panels/reports/delete`, request);
  }

}
